// Lightweight, dependency-free confetti burst fired from the left and right
// edges of the viewport. Exposed as window.fireCartConfetti().
(function () {
    if (window.fireCartConfetti) return;

    var COLORS = ['#ffcc00', '#233199', '#ffffff', '#4ade80', '#f97316'];
    var GRAVITY = 0.28;
    var DRAG = 0.995;
    var DURATION = 2600;
    var FADE_START = DURATION - 500;
    var PARTICLE_COUNT = 60;

    function makeCanvas(side) {
        var canvas = document.createElement('canvas');
        canvas.className = 'cartConfettiCanvas cartConfettiCanvas--' + side;
        var dpr = window.devicePixelRatio || 1;
        var width = window.innerWidth;
        var height = window.innerHeight;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        document.body.appendChild(canvas);
        var ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        return { canvas: canvas, ctx: ctx, width: width, height: height };
    }

    function makeParticles(side, width, height) {
        var particles = [];
        var originX = side === 'left' ? -10 : width + 10;
        var originY = height * 0.6;
        var dirSign = side === 'left' ? 1 : -1;

        for (var i = 0; i < PARTICLE_COUNT; i++) {
            var angle = -0.95 + (Math.random() - 0.5) * 0.9;
            var speed = 9 + Math.random() * 9;
            particles.push({
                x: originX,
                y: originY,
                vx: Math.cos(angle) * speed * dirSign,
                vy: Math.sin(angle) * speed,
                size: 6 + Math.random() * 6,
                color: COLORS[Math.floor(Math.random() * COLORS.length)],
                rotation: Math.random() * Math.PI * 2,
                rotationSpeed: (Math.random() - 0.5) * 0.35,
                shape: Math.random() > 0.5 ? 'rect' : 'circle',
                opacity: 1
            });
        }
        return particles;
    }

    function animate(setup, particles) {
        var startTime = performance.now();

        function frame(now) {
            var elapsed = now - startTime;
            setup.ctx.clearRect(0, 0, setup.width, setup.height);

            particles.forEach(function (p) {
                p.vy += GRAVITY;
                p.vx *= DRAG;
                p.x += p.vx;
                p.y += p.vy;
                p.rotation += p.rotationSpeed;
                if (elapsed > FADE_START) {
                    p.opacity = Math.max(0, 1 - (elapsed - FADE_START) / (DURATION - FADE_START));
                }

                setup.ctx.save();
                setup.ctx.translate(p.x, p.y);
                setup.ctx.rotate(p.rotation);
                setup.ctx.globalAlpha = p.opacity;
                setup.ctx.fillStyle = p.color;
                if (p.shape === 'circle') {
                    setup.ctx.beginPath();
                    setup.ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
                    setup.ctx.fill();
                } else {
                    setup.ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
                }
                setup.ctx.restore();
            });

            if (elapsed < DURATION) {
                requestAnimationFrame(frame);
            } else {
                setup.canvas.remove();
            }
        }

        requestAnimationFrame(frame);
    }

    window.fireCartConfetti = function () {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }
        ['left', 'right'].forEach(function (side) {
            var setup = makeCanvas(side);
            animate(setup, makeParticles(side, setup.width, setup.height));
        });
    };
})();
